import { render } from "./InfoFooter.vue?vue&type=template&id=69427961&scoped=true&ts=true"
import script from "./InfoFooter.vue?vue&type=script&lang=ts"
export * from "./InfoFooter.vue?vue&type=script&lang=ts"

import "./InfoFooter.vue?vue&type=style&index=0&id=69427961&scoped=true&lang=scss"

import exportComponent from "/home/apps/bugaplus/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69427961"]])

export default __exports__